module.exports = __webpack_public_path__ + "img/txt-icon.2d271a93.svg";